import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider } from 'styled-components/macro';
import 'react-toastify/dist/ReactToastify.css';

import GlobalStyle from './GlobalStyle';
import history from 'browserHistory';
import { AuthProvider } from 'contexts/AuthContext';
import MUIThemeProvider from 'contexts/MUIProvider';
import { ResponsiveProvider } from 'contexts/ResponsiveContext';
import AppRoutes from 'router/AppRoutes';
import Router from 'router/Router';
import mainTheme from 'theme/mainTheme';

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false } },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <AuthProvider>
        <ResponsiveProvider>
          <ThemeProvider theme={mainTheme}>
            <MUIThemeProvider>
              <Router history={history}>
                <GlobalStyle />
                <AppRoutes />
              </Router>
            </MUIThemeProvider>
          </ThemeProvider>
        </ResponsiveProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
